import { render, staticRenderFns } from "./BaseResourceAutoComplete.vue?vue&type=template&id=6eedbf2a&"
import script from "./BaseResourceAutoComplete.vue?vue&type=script&lang=js&"
export * from "./BaseResourceAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports